export const sectionNames = {
  income_from_individual_to_holder: 'Rendimentos Tributáveis Recebidos de Pessoa Física e do Exterior pelo Titular',
  income_from_individual_to_dependents: 'Rendimentos Tributáveis Recebidos de Pessoa Física e do Exterior pelos Dependentes',
}

export const sectionsMetadata = {
  months: [
    { key: 'jan', label: 'Janeiro' },
    { key: 'fev', label: 'Fevereiro' },
    { key: 'mar', label: 'Março' },
    { key: 'abr', label: 'Abril' },
    { key: 'mai', label: 'Maio' },
    { key: 'jun', label: 'Junho' },
    { key: 'jul', label: 'Julho' },
    { key: 'ago', label: 'Agosto' },
    { key: 'set', label: 'Setembro' },
    { key: 'out', label: 'Outubro' },
    { key: 'nov', label: 'Novembro' },
    { key: 'dez', label: 'Dezembro' },
  ],

  incomeColumns: [
    { key: 'unwaged_work', label: 'Trabalho não Assalariado', format: 'currency' },
    { key: 'rental', label: 'Aluguel', format: 'currency' },
    { key: 'others', label: 'Outros', format: 'currency' },
    { key: 'income_from_abroad', label: 'Exterior', format: 'currency' },
  ],

  deductionsColumns: [
    { key: 'official_social_security', label: 'Previdência Oficial', format: 'currency' },
    { key: 'dependents_number', label: 'Dependentes' },
    { key: 'alimony', label: 'Pensão Alimentícia', format: 'currency' },
    { key: 'cashbook', label: 'Livro Caixa', format: 'currency' },
  ],

  lionCarnetColumns: [
    { key: 'paid_darf_code_0190', label: 'Carnê-Leão (DARF 0190) Pago', format: 'currency' },
  ],
}
